import React, { FunctionComponent } from 'react'

import Spinner from '../../../App/Components/Spinner/Spinner'

import Body from './Body/Body'
import Header from './Header/Header'
import { IProps } from './IProps'

const ReportTable: FunctionComponent<IProps> = ({ results }) => {
    if (!results) {
        return <Spinner />
    }

    return (
        <>
            <table className={'table'}>
                <Header />
                <Body result={results} />
            </table>
        </>
    )
}

export default ReportTable
